import { Fragment } from "react"
import { NavLink } from "react-router-dom"
import DisclosureNavbarLinks from "../disclosure-navbar-links"
import NavItemPill from "../nav-item-pill"
import { classNames } from "../../utils"
import { NavItemType } from "../../../types"

type NavbarLinkProps = {
  isFull?: boolean
  isMobile?: boolean
  items: NavItemType[]
  setSidebarOpen: (open: boolean) => void
}

const NavbarLinks = ({
  isFull,
  isMobile,
  items,
  setSidebarOpen
}: NavbarLinkProps) => {
  const isCollapsed = !isFull && !isMobile

  const setClassList = (isActive: boolean) =>
    classNames(
      "group flex items-center px-2 py-2 rounded-md sm:hover:bg-white/[.1] sm:hover:text-white transition-colors",
      isActive ? "bg-white/[.1] text-white" : "text-white/[.6]",
      isMobile
        ? "text-base"
        : classNames(
            "text-sm cursor-pointer whitespace-nowrap",
            isFull ? "overflow-hidden" : ""
          ),
      isMobile ? "" : isFull ? "justify-start" : "justify-center"
    )

  const setIconClassList = (isActive: boolean, hasNoMargin?: boolean) =>
    classNames(
      isActive ? "text-white" : "text-white/[.6]",
      hasNoMargin ? "mr-0" : isMobile ? "mr-4" : isFull ? "mr-3" : "mr-0",
      "flex-shrink-0 sm:group-hover:text-white transition-colors"
    )

  return (
    <>
      {items.map((item, index) => (
        <Fragment key={`menu-${item.key}-${index}`}>
          {!item.children || isCollapsed ? (
            <NavLink
              key={`menu-${item.key}`}
              to={item.href}
              className={({ isActive }) =>
                classNames(
                  setClassList(isActive),
                  isCollapsed ? "relative" : ""
                )
              }
              onClick={() => setSidebarOpen(false)}
              title={isCollapsed ? item.name : undefined}
            >
              {({ isActive }) => (
                <>
                  {isCollapsed && isActive && (
                    <span className="absolute left-0 inset-y-1 w-0.5 rounded-full bg-primary-400" />
                  )}
                  <item.icon
                    size={20}
                    aria-hidden="true"
                    className={setIconClassList(isActive)}
                  />
                  {/* The pill only fits when the sidebar is expanded, so keep
                      the signal visible as a dot while it is collapsed. */}
                  {isCollapsed && item.pill && (
                    <span
                      className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-[#786FF6]"
                      aria-hidden="true"
                    />
                  )}
                  {(isFull || isMobile) && (
                    <span className="flex flex-1 items-center gap-2 min-w-0">
                      <span className="truncate">{item.name}</span>
                      {item.pill && <NavItemPill>{item.pill}</NavItemPill>}
                    </span>
                  )}
                </>
              )}
            </NavLink>
          ) : (
            <DisclosureNavbarLinks
              item={item}
              isFull={isFull}
              isMobile={isMobile}
              setClassList={setClassList}
              setIconClassList={setIconClassList}
            />
          )}
        </Fragment>
      ))}
    </>
  )
}

export default NavbarLinks
